/** The 0-indexed month of a `fiscal_year_start` setting value, or `null` when it is unset or unparseable. */
export const parseFiscalYearStartMonth = (raw?: string): number | null => {
  if (!raw) return null;
  const month = new Date(raw).getUTCMonth();
  return Number.isFinite(month) ? month : null;
};
